import { Box, Text } from '@chakra-ui/react';

import { Checkbox } from './formComponents';

type CaliforniaSharingConsentProps = {
  text: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
};

const CaliforniaSharingConsent = ({ text, checked, onChange }: CaliforniaSharingConsentProps) => {
  const paragraphs = text.split('\n\n');
  const checkboxLabel = paragraphs.pop();

  return (
    <Box
      textAlign="left"
      color="gray"
      bgColor="blue.50"
      borderRadius="lg"
      border="1px solid"
      borderColor="blue.100"
      p={4}
      fontSize="12px"
    >
      <Text whiteSpace="pre-line" mb={2}>
        {paragraphs.join('\n\n')}
      </Text>
      <Checkbox
        m={0}
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        label={
          <Text fontWeight="bold" fontSize="12px" color="leaseEndBlue">
            {checkboxLabel}
          </Text>
        }
        alignItems="flex-start"
        p={0}
        _hover={{}}
        sx={{ '.chakra-checkbox__label': { ml: 2 } }}
      />
    </Box>
  );
};

export default CaliforniaSharingConsent;
